import React from 'react';
import { Link } from 'react-router';

export default class IndustryTabSidebar extends React.Component {
  render() {
    let industryId = this.props.params.industryId;
    const { activeTab } = this.props;
    return (
       <div className="industries-sidebar-section">
          <ul>
            <li className={activeTab === 'IndustryDetails' ? 'active' : 'not'}>
              <Link to={`/industries/${industryId}`}>
                Details
              </Link>
            </li>
            { industryId !== 'new' &&
              <li className={activeTab === 'IndustryOrganisations' ? 'active' : 'not'}>
                <Link to={`/industries/${industryId}/organisations`}>
                  Organisations
                </Link>
              </li>
            }
            { industryId !== 'new' &&
              <li className={activeTab === 'IndustryInsightSets' ? 'active' : 'not'}>
              <Link to={`/industries/${industryId}/insight-sets`}>
                  Insights Sets
                </Link>
              </li>
            }
            { industryId !== 'new' &&
              <li className={activeTab === 'IndustryShapeSets' ? 'active' : 'not'}>
                <Link to={`/industries/${industryId}/catchment-sets`}>
                  Catchment Sets
                </Link>
              </li>
            }
            </ul>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/industries/IndustryTabSidebar.js